import React from "react";
import { withActions } from "containers/HOC";
import * as api from "api";

const getZendeskToken = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        return dispatch(
            api.get({
                path: `accounts/zendesktoken`,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject(error);
                    return [];
                },
            })
        );
    });
};

const ZendeskLink = withActions({ getZendeskToken })(({ children, title, url, className, anchorRef, getZendeskToken }) => {
    const handleClick = (e) => {
        const zendeskAuthRequired = process.env.REACT_APP_ZENDESK_JWT === "true";
        if (zendeskAuthRequired) {
            e.preventDefault();
            const url = e.currentTarget.href;
            getZendeskToken()
                .then((zendeskToken) => {
                    const redirectUrl = `https://overseer-helpdesk.zendesk.com/access/jwt?jwt=${zendeskToken.token}&return_to=${encodeURI(url)}`;
                    window.open(redirectUrl, "_blank");
                })
                .catch();
        }
    };
    return (
        <a href={url} onClick={handleClick} className={className} ref={anchorRef} target="_blank" rel="noopener noreferrer">
            {children || title || url}
        </a>
    );
});

export default React.forwardRef((props, ref) => <ZendeskLink {...props} anchorRef={ref} />);
